

import React from "react";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
// react component that creates a dropdown menu for selection
import "react-select/dist/react-select.css";
// react component that creates a dropdown menu for selecting a date
import Datetime from "react-datetime";
import ReactDOM from 'react-dom';
import rest from "../../../API/api";


import SweetAlert from "react-bootstrap-sweetalert";


class Step2 extends React.Component {
  constructor(props) {
    super(props);
    this._grabUserInput = this._grabUserInput.bind(this);
    this.handleChangeSubscription = this.handleChangeSubscription.bind(this);
    this.handleChangeSubscriptionMultiShopCount = this.handleChangeSubscriptionMultiShopCount.bind(this);
    this.calculateSubscriptionPrice = this.calculateSubscriptionPrice.bind(this);
    this.state = {
      SubscriptionType: props.getStore().SubscriptionType,
      SubscriptionMultiShopCount: props.getStore().SubscriptionMultiShopCount,
      SubscriptionDate: props.getStore().SubscriptionDate,
      SubscriptionPrice: props.getStore().SubscriptionPrice,
      Userid: props.getStore().Userid,
      Password: props.getStore().Password,
      ConfirmPassword: props.getStore().ConfirmPassword,
      Kioskid: props.getStore().Kioskid,
      KioskPassword: props.getStore().KioskPassword,
      KioskConfirmPassword: props.getStore().KioskConfirmPassword,


      SubscriptionTypeError: null,
      SubscriptionMultiShopCountError: null,
      SubscriptionDateError: null,
      UseridError: null,
      PasswordError: null,
      ConfirmPasswordError: null,
      KioskidError: null,
      KioskPasswordError: null,
      KioskConfirmPasswordError: null,
      ccnumberError: null,
      ccnameError: null,
      ccexpiryError: null,
      cccvcError: null,
      ccissuerError: null,
      ccfocusedError: null,
      ccformDataError: null,

    };
  }

passwordWeakAlert(field,message_s){
    (field === "Password") ? (
        this.setState({
                PasswordError: (
                    <small className="text-danger">
                        {message_s}
                    </small>
                ),
                ConfirmPasswordError: (
                    <small className="text-danger">
                        {message_s}
                    </small>
                )
            }
        )
    ) : (
        this.setState({
                KioskPasswordError: (
                    <small className="text-danger">
                        {message_s}
                    </small>
                ),
                KioskConfirmPasswordError: (
                    <small className="text-danger">
                        {message_s}
                    </small>
                )
            }
        )
    )
}


    passwordMismatchAlert(field,message_s){
        (field === "Password") ? (
            this.setState({
                    PasswordError: (
                        <small className="text-danger">
                            Passwords Must Match!
                        </small>
                    ),
                    ConfirmPasswordError: (
                        <small className="text-danger">
                            Passwords Must Match!
                        </small>
                    )
                }
            )
        ) : (
            this.setState({
                    KioskPasswordError: (
                        <small className="text-danger">
                            Passwords must Match!
                        </small>
                    ),
                    KioskConfirmPasswordError: (
                        <small className="text-danger">
                            Passwords must Match!
                        </small>
                    )
                }
            )
        )
    }
    passwordTooShortAlert(field,message_s) {
        {
            (field === "Password") ? (
                this.setState({
                        PasswordError: (
                            <small className="text-danger">
                                At least 8 chars
                            </small>
                        )
                    }
                )
            ) : (
                this.setState({
                        KioskPasswordError: (
                            <small className="text-danger">
                                At least 8 chars
                            </small>
                        )
                    }
                )
            )
        }
    }

    duplicateUseridAlert(field,message_s){
        {
            (field === "Userid") ? (
                this.setState({
                        UseridError: (
                            <small className="text-danger">
                                Userid already exists!
                            </small>
                        )
                    }
                )
            ) : (
                this.setState({
                        KioskidError: (
                            <small className="text-danger">
                                Kiosk Userid already exists!
                            </small>
                        )
                    }
                )
            )
        }
    }

    sameUseridAlert(message_s){
        {
            this.setState({
                    UseridError: (
                        <small className="text-danger">
                            User Id cannot be same as Kiosk User Id!
                        </small>
                    )
                });

            this.setState({
                    KioskidError: (
                        <small className="text-danger">
                            Kiosk User Id cannot be the same as User Id!
                        </small>
                    )
                });

        }
    }

  async isValidated() {
      //lets look up user and see if it exists
      var userid_good=
         await fetch(rest.getUserSalt, {
              method: 'POST',
              body: JSON.stringify({
                  username: document.getElementById('Userid').value

              }),
              insecure: true,
              headers: new Headers({
                  'Content-Type': 'application/json;charset=UTF-8',
                  'x-api-key': rest.apiKey
              })
          })
              .then(response => response.json())
              .then(data => {
                  //Check for duplicate User ID
                  if (data.exist) {
                      //console.log(data);
                      this.duplicateUseridAlert("Userid","User ID already exists!");
                      return !(data.exist);
                  }
                  else {
                      this.setState({ UseridError: null });
                      return (true)
                  }
              })
              .catch(error => console.error(error));
      //Lets look up the kiosk user and see if it exists
      var kioskid_good =
          await fetch(rest.getKioskUserSalt, {
          method: 'POST',
          body: JSON.stringify({
              username: document.getElementById('Kioskid').value

          }),
          insecure: true,
          headers: new Headers({
              'Content-Type': 'application/json;charset=UTF-8',
              'x-api-key': rest.apiKey
          })
      })
          .then(response => response.json())
          .then(data => {
              //Check for duplicate User ID
              if (data.exist) {
                  //console.log(data);
                  this.duplicateUseridAlert("KioskUserid","Kiosk User ID already exists!");
                  return !(data.exist);
              }
              else{
                  this.setState({ KioskidError: null });
                  return (true)
              }
          })
          .catch(error => console.error(error));

      ((this.state.SubscriptionType === "Select a subscription type") || (this.state.SubscriptionType === ""))
          ? this.setState({
              SubscriptionTypeError: (
                  <small className="text-danger">
                      Please provide a subscription type.
                  </small>
              )
          })
          : this.setState({SubscriptionTypeError: null});

      var type = ((this.state.SubscriptionType !== "Select a subscription type") && (this.state.SubscriptionType !== ""));

      this.state.SubscriptionMultiShopCount === ""
          ? this.setState({
              SubscriptionMultiShopCountError: (
                  <small className="text-danger">
                      Use value of 0 if none.
                  </small>
              )
          })
          : this.setState({SubscriptionMultiShopCountError: null});
      var count = this.state.SubscriptionMultiShopCount !== "";

      this.state.SubscriptionDate === ""
          ? this.setState({
              SubscriptionDateError: (
                  <small className="text-danger">
                      Please provide a subscription type to calculate renewal date.
                  </small>
              )
          })
          : this.setState({SubscriptionDateError: null});
      var subscription = this.state.SubscriptionDate !== "";

      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //Only run this test if user id was not a duplicate from above
      if(this.state.UseridError === null)
          re.test(this.state.Userid) === false
              ? this.setState({
                  UseridError: (
                      <small className="text-danger">
                          Userid is required and format should be <i>john@doe.com</i>.
                      </small>
                  )
              })
              : this.setState({ UseridError: null });

      this.state.Password === ""
          ? this.setState({
              PasswordError: (
                  <small className="text-danger">
                      Please provide a password.
                  </small>
              )
          })
          : this.setState({ PasswordError: null });
      var password = this.state.Password !== "";

      this.state.ConfirmPassword === ""
          ? this.setState({
              ConfirmPasswordError: (
                  <small className="text-danger">
                      Please confirm the password.
                  </small>
              )
          })
          : this.setState({ ConfirmPasswordError: null });
      var confirm_password = this.state.ConfirmPassword !== "";

      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //Only run this test if user id was not a duplicate from above
      if(this.state.KioskidError === null)
          re.test(this.state.Kioskid) === false
              ? this.setState({
                  KioskidError: (
                      <small className="text-danger">
                          Kiosk user id is required and format should be <i>john@doe.com</i>.
                      </small>
                  )
              })
              : this.setState({ KioskidError: null });

      this.state.KioskPassword === ""
          ? this.setState({
              KioskPasswordError: (
                  <small className="text-danger">
                      Please provide a password.
                  </small>
              )
          })
          : this.setState({ KioskPasswordError: null });
      var kiosk_password = this.state.Password !== "";

      this.state.KioskConfirmPassword === ""
          ? this.setState({
              KioskConfirmPasswordError: (
                  <small className="text-danger">
                      Please confirm the password.
                  </small>
              )
          })
          : this.setState({ KioskConfirmPasswordError: null });
      var kiosk_confirm_password = this.state.ConfirmPassword !== "";

      // console.log(this.state,urlRex.test(this.state.website),(this.state.languageSelect !== null),what);
      var valid = (type && count && subscription && re.test(this.state.Userid) && password && confirm_password && userid_good && re.test(this.state.Kioskid) && kiosk_password && kiosk_confirm_password && kioskid_good);
      const userInput = this._grabUserInput(); // grab user entered vals
      if(valid) {
          var passwordRequirementsEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
          //Lets check to see if the userid and Kioskid are the same, they have to be unique!
          if ((document.getElementById('Userid').value) === (document.getElementById('Kioskid').value)) {
              this.sameUseridAlert("User and Kiosk ids cannot be the same, please correct them!");
              return !(valid);
          }
          //Check to see if the User Id passwords match
          if ((document.getElementById('Password').value) !== (document.getElementById('ConfirmPassword').value)) {
              this.passwordMismatchAlert("Password","User Id Password mismatch, please correct the passwords!");
              return !(valid);
          }
          //Check the password requirements against the regular expression
          if(!passwordRequirementsEx.test(userInput.Password)){
              this.passwordWeakAlert("Password","Password requirements not met!");
              return !(valid);
          }
          //Check length of User Id Passwords
          if (userInput.Password.length < 8) {
              this.passwordTooShortAlert("Password","User Id Password too short, password must be at least 8 characters!");
              return !(valid);
          }
          //Check to see if the Kiosk Id passwords match
          if ((document.getElementById('KioskPassword').value) !== (document.getElementById('KioskConfirmPassword').value)) {
              this.passwordMismatchAlert("KioskPassword","Kiosk Id Password mismatch, please correct the passwords!");
              return !(valid);
          }
          //Check the Kiosk Id password requirements against the regular expression
          if(!passwordRequirementsEx.test(userInput.KioskPassword)){
              this.passwordWeakAlert("KioskPassword","Password requirements not met!");
              return !(valid);
          }
          //Check length of Kiosk Id Passwords
          if (userInput.KioskPassword.length < 8) {
              this.passwordTooShortAlert("KioskPassword","Kiosk Id Password too short, password must be at least 8 characters!");
              return !(valid);
          }
          this.props.updateStore({
              ...userInput,
              sentEmail: false // use this to notify step4 that some changes took place and prompt the user to save again
          });
      }
      return valid;


  }
    _grabUserInput() {
        return {
            SubscriptionType: ReactDOM.findDOMNode(this.subscriptionType).value,
            SubscriptionMultiShopCount: document.getElementById('MultiShopCount').value,
            SubscriptionPrice: document.getElementById('SubscriptionPrice').value,
            SubscriptionDate: document.getElementById('SubscriptionDate').value,
            Password: document.getElementById('Password').value,
            ConfirmPassword: document.getElementById('ConfirmPassword').value,
            Userid: document.getElementById('Userid').value,
            KioskPassword: document.getElementById('KioskPassword').value,
            KioskConfirmPassword: document.getElementById('KioskConfirmPassword').value,
            Kioskid: document.getElementById('Kioskid').value,
        };
    }
    calculateSubscriptionPrice= () => {
        //Lets get the subscription type and multi-shop count values and calculate their price.
        let count_s = document.getElementById('MultiShopCount').value;
        let type_s = ReactDOM.findDOMNode(this.subscriptionType).value;
        var todayDate = new Date();
        var tenantDate,mm,dd,yyyy;
        var tenantDate_s = "";
        let price = 0;
        switch(type_s){
            case "Monthly" :
                price = rest.Monthly + (count_s * rest.MultiShop);
                tenantDate = new Date(todayDate.setMonth(todayDate.getMonth()+1));
                //Lets store the subscription date into a mm/dd/yyyy string
                dd = tenantDate.getDate();
                mm = tenantDate.getMonth() + 1; //January is 0!
                yyyy = tenantDate.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                tenantDate_s = mm + '/' + "01" + '/' + yyyy;
                break;
            case "Yearly" :
                price = rest.Yearly + (count_s * rest.MultiShop * 12);
                tenantDate = new Date(todayDate.setMonth(todayDate.getMonth()+12));
                //Lets store the subscription date into a mm/dd/yyyy string
                dd = tenantDate.getDate();
                mm = tenantDate.getMonth() + 1; //January is 0!
                yyyy = tenantDate.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                tenantDate_s = mm + '/' + "01" + '/' + yyyy;
                break;
            default:
                price = count_s * rest.MultiShop;
        }
        this.setState({
            SubscriptionPrice: price,
            SubscriptionDate: tenantDate_s
        });
    };

    handleChangeSubscription = () => {
        this.setState({ SubscriptionType: ReactDOM.findDOMNode(this.subscriptionType).value });
        this.calculateSubscriptionPrice();
    };

    handleChangeSubscriptionMultiShopCount = () => {
        this.setState({ SubscriptionMultiShopCount: document.getElementById('MultiShopCount').value });
        this.calculateSubscriptionPrice();
    };

  render() {
    let monthly_s = "TRO Monthly @ $" + rest.Monthly + " per month";
    let yearly_s = "TRO Yearly @ $" + rest.Yearly  + " per year";
    return (
      <div className="wizard-step">
          <Row>
              <Col md={10} mdOffset={1}>
                  <hr />
                  <h6>As noted on our pricing page, We offer a monthly and yearly plan.  The Yearly plan is our best
                  value, offering significant savings over our monthly plan.  If you have multiple shop locations and would like to
                  provide them with Kiosk access please indicate the number of additional shops.  We will calculate your
                  subscription price based on whether you selected monthly or yearly and the number of additional shops.</h6>
                  <hr />
              </Col>
          </Row>
          <Row>
              <Col md={3} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>Subscription Plan. <span className="text-danger">*</span> </ControlLabel>
                      {(this.state.SubscriptionTypeError === null) ? (
                          <FormControl componentClass="select"
                                       className="valid"
                                       placeholder="Select a subscription type"
                                       ref={subscriptionType => { this.subscriptionType= subscriptionType }}
                                       onChange={this.handleChangeSubscription}
                                       value={this.state.SubscriptionType}
                          >
                              <option value="Select a subscription type">Select a subscription type</option>
                              <option value="Monthly">Monthly</option>
                              <option value="Yearly">Yearly</option>
                          </FormControl>
                          ) : (
                          <FormControl componentClass="select"
                                       className="error"
                                       placeholder="Select a subscription type"
                                       ref={subscriptionType => { this.subscriptionType= subscriptionType }}
                                       onChange={this.handleChangeSubscription}
                                       value={this.state.SubscriptionType}
                          >
                              <option value="Select a subscription type">Select a subscription type</option>
                              <option value="Monthly">Monthly</option>
                              <option value="Yearly">Yearly</option>
                          </FormControl>
                      )}
                      {this.state.SubscriptionTypeError}
                  </FormGroup>
              </Col>
              <Col md={3}>
                  <FormGroup>
                      <ControlLabel>Multi-Shop Count: <span className="text-danger">*</span></ControlLabel>
                      {(this.state.SubscriptionMultiShopCountError === null) ? (
                          <FormControl
                              className="valid"
                              id="MultiShopCount"
                              type="number"
                              name="multishopcount"
                              placeholder="ex: 0"
                              value={this.state.SubscriptionMultiShopCount}
                              onChange={this.handleChangeSubscriptionMultiShopCount}
                              //onChange={event => this.setState({SubscriptionMultiShopCount: event.target.value})}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="MultiShopCount"
                              type="number"
                              name="multishopcount"
                              placeholder="ex: 0"
                              value={this.state.SubscriptionMultiShopCount}
                              onChange={this.handleChangeSubscriptionMultiShopCount}
                              //onChange={event => this.setState({SubscriptionMultiShopCount: event.target.value})}
                          />
                      )}
                      {this.state.SubscriptionMultiShopCountError}
                  </FormGroup>
              </Col>
              <Col md={3}>
                  <FormGroup>
                      <ControlLabel>Price (USD): <span className="text-danger">*</span></ControlLabel>
                      <FormControl
                          id="SubscriptionPrice"
                          type="number"
                          name="subscriptionprice"
                          placeholder="0"
                          value={this.state.SubscriptionPrice}
                          disabled={true}
                          //onChange={event => this.setState({SubscriptionPrice: event.target.value})}
                      />
                      {this.state.SubscriptionPriceError}
                  </FormGroup>
              </Col>
          </Row>
          <Row>
              <Col md={10} mdOffset={1}>
                  <hr />
                  <h6>This is the date for your second billing event, we will bill the amount calculated above in
                      in the Subscription Price field for your selected plan upon signing up.</h6>
                  <hr />
              </Col>
          </Row>
          <Row>
              <Col md={3} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>Next Renewal Date</ControlLabel>
                      <FormControl
                          id="SubscriptionDate"
                          type="text"
                          name="SubscriptionDate"
                          disabled={true}
                          placeholder="Next Subscription Renewal Date"
                          value={this.state.SubscriptionDate}
                      />
                  </FormGroup>
              </Col>
          </Row>
          <Row>
              <Col md={10} mdOffset={1}>
                  <hr />
                  <h6>User Ids should be formatted as an email address and must be unqiue to TRO, we only
                      use the email address on the previous page to contact you about your account. (The User Id and
                      the Kiosk User Id CANNOT be the same)
                      <br /><br />All passwords must meet the following guidelines:<br />
                      <ul>
                          <li>Password must contain at least 1 lowercase alphabetical character</li>
                          <li>Password must contain at least 1 uppercase alphabetical character</li>
                          <li>Password must contain at least 1 numeric character</li>
                          <li>Password must contain at least one special character</li>
                          <li>Password must be eight characters or longer</li>
                      </ul>
                  </h6>
                  <hr />
              </Col>
          </Row>
          <Row>
              <Col md={5} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>User ID (Use your email address) <span className="text-danger">*</span></ControlLabel>
                      {(this.state.UseridError === null) ? (
                          <FormControl
                              className="valid"
                              id="Userid"
                              type="email"
                              name="userid"
                              placeholder="ex: username@gmail.com"
                              value={this.state.Userid}
                              onChange={event => this.setState({Userid: event.target.value})}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="Userid"
                              type="email"
                              name="userid"
                              placeholder="ex: username@gmail.com"
                              value={this.state.Userid}
                              onChange={event => this.setState({Userid: event.target.value})}
                          />
                      )}
                      {this.state.UseridError}
                  </FormGroup>
              </Col>
              <Col md={3}>
                  <FormGroup>
                      <ControlLabel>Password  <span className="text-danger">*</span></ControlLabel>
                      {(this.state.PasswordError === null) ? (
                          <FormControl
                              className="valid"
                              id="Password"
                              type="password"
                              name="password"
                              placeholder="ex: 1Swe456#@$"
                              value={this.state.Password}
                              onChange={event => this.setState({Password: event.target.value})}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="Password"
                              type="password"
                              name="password"
                              placeholder="ex: 1Swe456#@$"
                              value={this.state.Password}
                              onChange={event => this.setState({Password: event.target.value})}
                          />
                      )}
                      {this.state.PasswordError}
                  </FormGroup>
              </Col>
              <Col md={3}>
                  <FormGroup>
                      <ControlLabel>Confirm Password <span className="text-danger">*</span></ControlLabel>
                      {(this.state.ConfirmPasswordError === null) ? (
                          <FormControl
                              className="valid"
                              id="ConfirmPassword"
                              type="password"
                              name="confirm_password"
                              placeholder="ex: 1Swe456#@$"
                              value={this.state.ConfirmPassword}
                              onChange={event => this.setState({ConfirmPassword: event.target.value})}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="ConfirmPassword"
                              type="password"
                              name="confirm_password"
                              placeholder="ex: 1Swe456#@$"
                              value={this.state.ConfirmPassword}
                              onChange={event => this.setState({ConfirmPassword: event.target.value})}
                          />
                      )}
                      {this.state.ConfirmPasswordError}
                  </FormGroup>
              </Col>
          </Row>
          <Row>
              <Col md={10} mdOffset={1}>
                  <hr />
                  <h6>Kiosk Ids are used for logging into your consent Kiosk stations to process client consent forms and they must also be unique to TRO.
                  You can add more Kiosk logins using your tenant credentials that you provided above.  Kiosk logins are preferred
                  over using your tenant credentials to process consent forms because they ONLY allow access to processing consent forms, nothing else.
                  We will create the first one for you!</h6>
                  <hr />
              </Col>
          </Row>
          <Row>
              <Col md={5} mdOffset={1}>
                  <FormGroup>
                      <ControlLabel>Kiosk User ID (Use an email address) <span className="text-danger">*</span></ControlLabel>
                      {(this.state.KioskidError === null) ? (
                          <FormControl
                              className="valid"
                              id="Kioskid"
                              type="email"
                              name="kioskid"
                              placeholder="ex: KioskUserName@gmail.com"
                              value={this.state.Kioskid}
                              onChange={event => this.setState({Kioskid: event.target.value})}
                          />
                          ) :(
                          <FormControl
                              className="error"
                              id="Kioskid"
                              type="email"
                              name="kioskid"
                              placeholder="ex: KioskUserName@gmail.com"
                              value={this.state.Kioskid}
                              onChange={event => this.setState({Kioskid: event.target.value})}
                          />
                      )}
                      {this.state.KioskidError}
                  </FormGroup>
              </Col>
              <Col md={3}>
                  <FormGroup>
                      <ControlLabel>Kiosk Password  <span className="text-danger">*</span></ControlLabel>
                      {(this.state.KioskPasswordError === null) ? (
                          <FormControl
                              className="valid"
                              id="KioskPassword"
                              type="password"
                              name="kioskpassword"
                              placeholder="ex: 1Swe456#@$"
                              value={this.state.KioskPassword}
                              onChange={event => this.setState({KioskPassword: event.target.value})}
                          />
                          ) : (
                          <FormControl
                              className="error"
                              id="KioskPassword"
                              type="password"
                              name="kioskpassword"
                              placeholder="ex: 1Swe456#@$"
                              value={this.state.KioskPassword}
                              onChange={event => this.setState({KioskPassword: event.target.value})}
                          />
                      )}
                      {this.state.KioskPasswordError}
                  </FormGroup>
              </Col>
              <Col md={3}>
                  <FormGroup>
                      <ControlLabel>Confirm Password <span className="text-danger">*</span></ControlLabel>
                      {(this.state.KioskConfirmPasswordError === null) ? (
                          <FormControl
                              className="valid"
                              id="KioskConfirmPassword"
                              type="password"
                              name="Kiosk_confirm_password"
                              placeholder="ex: 1Swe456#@$"
                              value={this.state.KioskConfirmPassword}
                              onChange={event => this.setState({KioskConfirmPassword: event.target.value})}
                          />
                          ) : (
                          <FormControl
                              id="KioskConfirmPassword"
                              className="error"
                              type="password"
                              name="Kiosk_confirm_password"
                              placeholder="ex: 1Swe456#@$"
                              value={this.state.KioskConfirmPassword}
                              onChange={event => this.setState({KioskConfirmPassword: event.target.value})}
                          />
                      )}
                      {this.state.KioskConfirmPasswordError}
                  </FormGroup>
              </Col>
          </Row>
          {this.state.alert}
      </div>
    );
  }
}

export default Step2;



// WEBPACK FOOTER //
// ./src/views/Forms/RegisterWizard/Step2.jsx